<template>
  <div class="lr-page" v-if="lrShow">
    <div :class="'lr-panel '+this.lrObj.cls">
      <div class="title-panel">
        <div class="title" v-text="lrObj.title"></div>
        <div class="close" @click="hideSelf" v-if="lrType!=3"></div>
      </div>
      <div class="content-panel" v-if="lrType==2||step==1">
        <div class="fuc-panel">
          <div class="title">Email <span class="msg" v-text="emailError"></span></div>
          <input type="text" class="input-content" placeholder="Your e-mail address" v-model="email" @blur="checkEmail">
        </div>
        <div class="fuc-panel">
          <div class="title">Password <span class="msg" v-text="passwordError"></span></div>
          <input type="password" class="input-content" placeholder="6-32 characters" v-model="password"
                 onfocus="this.type='password'">
        </div>
      </div>
      <div class="content-panel verification" v-if="lrType!=2&&step==2">
        <div class="verification-title">We sent you a verification code</div>
        <div class="verification-title-sub">Enter it below to verify your email.</div>
        <div class="verification-input-panel">
          <div class="verification-input" v-for="(item, index) in inputList">
            <input type="number" v-model="item.pinless" class="inputValue" @keyup="keyboard($event, index)"
                   @keydown="expurgate(index)"/>
          </div>

        </div>
        <div :class="'verification-resend-panel '+(hasSend?'':'active')" @click.stop="sendVerificationCode()">Didn't
          receive the email?Resend <span
            v-if="left>0"
            v-text="'('+left+'s)'"></span>
        </div>
      </div>
      <div class="action-panel">
        <div :class="'action '+(lrType==2||step!=2||completeCode?'':'disable')" v-text="this.lrObj.action"
             @click="doAction"></div>
        <div class="tips-panel" v-if="this.lrType==1">Already have an account? <span class="tip-action"
                                                                                     @click="toLogin">Sign in</span>
        </div>
        <div class="tips-panel" v-if="this.lrType==2"><span class="tip-action"
                                                            @click="toForgot">Forgot password?</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../../router'
  import {hideDialog, isLegalEmail, isnull, localClear, localGet, Toast, validatePWD} from "../../utils/tools";
  import {checkEmail, doBind, doLogin, doReg, sendEmailCode} from "../../api/home-api";
  import TipsUtils from "../../utils/TipsUtils";
  import IMManager from "../../im/IMManager";

  export default {
    name: "loginreg",
    props: {
      type: {
        default: 1
      },
      lrShow: {
        default: false
      },
      from: {
        default: '',
        type: String,
      }
    },
    data() {
      return {

        lrType: this.type,
        lrObj: {},
        nickname: '',
        nicknameError: '',
        email: '',
        emailError: '',
        password: '',
        passwordError: '',
        step: 1,
        left: 60,
        hasSend: false,
        resendTimerId: null,
        completeCode: false,
        inputList: [
          {pinless: ""},
          {pinless: ""},
          {pinless: ""},
          {pinless: ""},
          {pinless: ""},
          {pinless: ""},
        ],
        vCode: '',
      }
    },

    methods: {
      refreshVCode() {
        let code = ''
        this.inputList.forEach((item) => {
          code += item.pinless
        })

        this.completeCode = code.length == 6
        this.vCode = code
      },
      // 键盘松开事件
      keyboard(e, index) {
        let domNode = document.getElementsByClassName("inputValue"),
          currInput = domNode[index],
          nextInput = domNode[index + 1],
          lastInput = domNode[index - 1];
        if (e.keyCode != 8) {
          if (index < this.inputList.length - 1) {
            nextInput.focus();
          } else {
            currInput.blur();
          }
          this.refreshVCode()
        } else {
          if (index != 0) {
            lastInput.focus();
          }
        }
      },
      // 键盘按下触发
      expurgate(index) {
        this.inputList[index].pinless = "";
      },
      clearResendTimer() {
        if (this.resendTimerId)
          clearTimeout(this.resendTimerId)
      },
      startResendTimer() {
        this.clearResendTimer()
        let _this = this
        this.resendTimerId = setTimeout(() => {
          _this.left--
          if (_this.left <= 0) {
            _this.left = 0
            _this.hasSend = false
          } else {
            _this.startResendTimer()
          }
        }, 1000)
      },
      checkEmail() {
        if (!isLegalEmail(this.email)) {
          this.emailError = '(Incorrect Email format!)'
          Toast.error('Incorrect Email format', this)
          return
        }
      },
      wrapLRType() {
        this.lrObj = this.lrType == 1 || this.lrType == 3 ? {
          cls: 'signup',
          title: 'Bind your email',
          action: 'Next'
        } : {
          cls: 'signin',
          title: 'Sign in',
          action: 'Sign in'
        };
      },
      doAction() {
        if (isnull(this.email) || isnull(this.email.trim())) {
          this.emailError = '(Email is empty!)'
          Toast.error('Email is empty', this)
          return
        }
        this.email = this.email.trim()
        if (!isLegalEmail(this.email)) {
          this.emailError = '(Incorrect Email format!)'
          Toast.error('Incorrect Email format', this)
          return
        }
        if (isnull(this.password) || isnull(this.password.trim())) {
          this.passwordError = '(Password is empty!)'
          Toast.error('Password is empty', this)
          return
        }
        this.password = this.password.trim()
        if (this.password.replace(' ', '').length != this.password.length) {
          this.passwordError = '(Password can\'t contains blank space!)'
          Toast.error('Password can\'t contains blank space', this)
          return
        }
        this.password = this.password.replace(' ', '')
        if (this.password.length < 6 || this.password.length > 32) {
          this.passwordError = '(Incorrect Password length!)'
          Toast.error('Incorrect Password length', this)
          return
        }

        if (!validatePWD(this.password)) {
          this.verifyRes = '(Incorrect Password format!)'
          Toast.error('Incorrect Password format', this)
          return
        }

        if (this.lrType == 1 || this.lrType == 3) {

          if (this.step == 1) {
            this.sendVerificationCode()
          } else if (this.step == 2) {
            doBind(this.vCode, this.password, function (data, page) {
              page.step = 1
              page.clearResendTimer()
              page.doLoginAction()
            }, function (code, msg, page) {
              hideDialog(page)
              Toast.error(TipsUtils.getErrorTips(code), page)
            }, this, true, false)
          }

        } else {
          this.doLoginAction()
        }
      },
      sendVerificationCode() {
        if (this.hasSend)
          return
        sendEmailCode(this.email, function (data, page) {
          if (page.step != 2)
            page.step = 2
          page.hasSend = true
          page.left = 60
          page.startResendTimer()
        }, function (code, msg, page) {
          Toast.error(TipsUtils.getErrorTips(code), page)
        }, this)
      },
      doLoginAction() {
        doLogin(this.email, this.password, function (data, page) {
          router.go('/uc')
        }, function (code, msg, page) {
          Toast.error(TipsUtils.getErrorTips(code), page)
        }, this)
      },
      toLogin() {
        this.lrType = 2
        this.step = 1
      },
      toForgot() {
        this.hideSelf()
        router.togo({
          name: 'Password',
          params: {
            type: 1,
            from: this.from
          }
        })
      },
      hideSelf() {
        if (this.lrType != 2 && this.step == 2) {
          this.step = 1
          this.hasSend = false
          this.clearResendTimer()
        } else
          this.$emit('hideLogReg')
      }
    },

    watch: {
      lrType(n, o) {
        if (n)
          this.wrapLRType()
      },
      type(n, o) {
        this.lrType = n
      },
      lrShow(n, o) {
        if (n) {
          this.lrType = this.type
          this.wrapLRType()
          this.startResendTimer()
        }
      },
      step(n, o) {
        if (n == 2) {
          this.startResendTimer()
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .lr-page {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, .5);

    .lr-panel {
      .w(670);
      .h(840);
      background: #fff;
      .b-radius(30);
      top: 50%;
      left: 50%;
      position: fixed;
      transform: translate(-50%, -50%);

      .title-panel {
        .mt(57);

        .title {
          .fs(48);
          font-family: Gilroy-Medium;
          color: #1E2028;
          .lh(58);
          .ml(40);
          float: left;
        }

        .close {
          float: right;
          .mr(40);
          .w(54);
          .h(54);
          background: url(../../assets/imgs/page-close-btn.png) no-repeat;
          background-size: contain;
        }
      }

      .content-panel {
        .mt(172);
        .w(590);
        .ml(40);

        .fuc-panel {
          .mt(40);

          .title {
            text-align: left;
            .fs(24);
            font-family: Gilroy-Medium;
            color: #BAB3BD;
            .lh(40);

            .msg {
              color: #FF0E74;
              .lh(29);
            }

          }

          .input-content {
            .lh(58);
            .w(590);
            .fs(32);
            font-family: Gilroy-Medium;
            color: #1E2028;
            .lh(58);
          }

          .input-content::placeholder {
            color: #E1E1E1;
          }

        }

        .fuc-panel::after {
          content: '';
          background: #f1f0f2;
          .h(2);
          .w(590);
          display: block;
        }

      }

      .content-panel.verification {
        text-align: left;

        .verification-title {
          .fs(32);
          font-family: Gilroy-Bold;
          color: #1E2028;
        }

        .verification-title-sub {
          .fs(24);
          .mt(10);
          font-family: Gilroy-Bold;
          color: #BAB3BD;
        }

        .verification-input-panel {
          font-size: 0;
          display: flex;
          .margin(60, 0, 0, 0);
          flex-direction: row;
          justify-content: space-between;

          .verification-input, input {
            .w(83);
            .h(83);
            background: #f5f5f5;
            .b-radius(16);
            .fs(38);
            text-align: center;
            .lh(83);
            font-family: Gilroy-Bold;
            color: #1e2028;
          }
        }

        .verification-resend-panel {
          .fs(24);
          .mt(30);
          font-family: Gilroy-Bold;
          color: #BAB3BD;
        }

        .verification-resend-panel.active {
          .fs(24);
          font-family: Gilroy-Bold;
          color: #FF0E74;
        }
      }

      .action-panel {
        .w(590);
        .left(40);
        .right(40);
        position: absolute;
        .btm(40);

        .action {
          .w(590);
          .h(102);
          background: linear-gradient(270deg, #FB5F7C 0%, #FF32A1 100%);
          .b-radius(58);
          .fs(32);
          font-family: Gilroy-Medium;
          color: #FFFFFF;
          .lh(102);
          cursor: pointer;
        }

        .action.disable {
          .w(590);
          .h(102);
          background: rgba(199, 199, 199, 1);
          .b-radius(58);
          .fs(32);
          font-family: Gilroy-Medium;
          color: rgba(160, 158, 158, 1);
          .lh(102);
          cursor: pointer;
        }

        .tips-panel {
          .mt(40);
          .w(590);
          text-align: center;
          .fs(24);
          font-family: Gilroy-Medium;
          color: #BAB3BD;
          .lh(30);

          .tip-action {
            color: #FF0E74;
          }
        }
      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/components/widget/loginreg.vue